import { render, staticRenderFns } from "./app.private.vue?vue&type=template&id=8009dbdc&"
import script from "./app.private.vue?vue&type=script&lang=js&"
export * from "./app.private.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports